import ModalComponent from './Modal';
import { confirm } from './dialogs';

export const Modal = ModalComponent;

Modal.confirm = confirm;

export { default as useModal } from './useModal';
